import React, { useEffect } from "react";
import "./releases.css";
import Music from "./music/Music";
import { Helmet } from "react-helmet";

function Releases(props) {
  const pageTitle = "JXSRMA | " + props.title;
  const pageDescription = "Listen to JXSRMA's latest releases";
  const pageImage = "https://i.ibb.co/PFx9Bds/Glass.jpg";
  const pageUrl = "https://jxsrma.web.app/release";
  const siteName = "JXSRMA Official Website";
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  // https://codepen.io/Cyanek-S/pen/oNQwdEb
  return (
    <div className="releases" id="release">
      <Helmet>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={siteName} />
      </Helmet>
      <Music />
    </div>
  );
}

export default Releases;
